//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'HydroxyprolineInUrine',
  data() {
    return {
      defaultJson:{
        "UTHP": "尿羟脯氨酸浓度",
        "Ucr": "尿肌酐",
        "Weight": "体重",
      },
      form:{
        uthp:'',
        ucr:'',
        weight:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // 尿羟脯氨酸指数=尿羟脯氨酸浓度（mmol/L）/尿肌酐（mmol/L）/体重（kg）
        let result = form.uthp / (form.ucr / form.weight)
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/HydroxyprolineInUrine.vue